const news_CN_Locale = {
    'news.swiperName': '新闻动态',
    'news.swiperCenter': '企业新闻、学术会议、行业动态',
    'news.news25_1_1':'智能超声丨度影医疗联合广州中医药大学发表乳腺容积超声AI诊断的国际顶刊论文',
    'news.news25_1_2':'智能超声丨度影医疗联合暨南大学发表早孕期胎儿唇腭裂三维超声智能分析高水平论文',
    'news.news25_1_3':'智能超声丨度影医疗联合澳门理工大学发表超声影像质量控制算法高水平论文',
    'news.news25_1_4':'心动AI奖丨度影医疗罕见病超声AI筛查闪耀武田创新挑战赛!',
    'news.news12_1': '喜讯！度影医疗首席科学家倪东教授任医学影像国际顶级期刊IEEE TMI副主编',
    'news.news12_2': 'CSUM 2024 圆满结束度影医疗智能超声多领域创新突破！',
    'news.news12_3': '年终好礼品鉴丨Pair软件重磅推出三维医学影像万物分割神器i3D',
    'news.news12_4': '喜讯丨度影医疗启动智能化医学超声科研合作项目，改善妇幼健康',
    'news.news12_5': '度影医疗丨相约武汉CSUM 2024超声盛会，共绘超声AI的大江大河',
    'news.news12_6': '2024度影招聘季丨超声关爱，触手可及',
    'news.news12_7': '智能超声丨度影医疗斩获MICCAI大会Freehand超声重建挑战赛全球冠军',
    'news.news12_8': '风向标MICCAI 2024度影医疗四篇创新论文接收，智能超声加速迭代',
    'news.news12_9': 'AJOG顶刊!丨度影医疗联合浙江省人民医院发表智能盆底功能学诊断指标创新论文',
    'news.news12_10': '智能超声丨度影医疗联合南京医科大学附属苏州医院发表早孕胎儿颅脑参数智能分析高水平论文',
    'news.news12_11': '智能超声丨度影医疗联合南京医科大学附属苏州医院发表心脏超声高水平顶刊论文',
    'news.news12_12': '喜报！度影医疗获批乳腺超声影像处理软件NMPA注册证',
    'news.news1': "重磅丨Pair标注软件V3.0全面升级！更智能、更好看、更便捷",
    'news.news2': "盖茨基金会专访丨倪东：我们想让最新的医疗进步，为孕产妇保驾护航",
    'news.news3': "智能超声丨度影医疗联合深圳市宝安中医院发表智能盆底超声高水平论文",
    'news.news4': "度影医疗丨踏春出游，不负春光，五一劳动节快乐！",
    'news.news5': "2024度影招聘季丨向光而行，共赴智能超声新征程",
    'news.news6': "CMEF盛大闭幕丨度影医疗智能超声引领新质力量! ",
    'news.news7': "度影医疗丨相约CMEF 2024，共话智能超声新质生产力",
    'news.news8': "智能超声丨度影医疗联合深大总院发表产前超声智能多参数测量高水平文章",
    'news.news9': "智能超声丨度影医疗联合上海瑞金医院发表甲状腺超声智能诊断顶级期刊论文",
    'news.news10': "首创胎心CTIs正常值参考！度影医疗联合苏州市立医院发表胎心超声智能分析顶级期刊论文",
    'news.news11': "智能标注再加速丨Pair结合英伟达MONAI推出医学影像智能标注新范式",
    'news.news12': "新年首篇！度影医疗联合北京大学深圳医院发表智能盆底超声高水平论文",
    'news.news13': "度影医疗丨2024年，迎难而上，再越高峰",
    'news.news14': "重大突破！度影医疗主持获批粤港澳科技创新联合资助项目",
    'news.news15': "无界共创丨度影医疗首批入驻GE医疗中国最大创中心",
    'news.news16': "创新突破CSUM2023丨度影医疗智能超声全新亮相中华医学会超声盛会",
    'news.news17': "喜讯！度影医疗再添新空间，智能超声发展新势能",
    'news.news18': "智能超声丨度影医疗联合苏州市立医院发表早孕胎儿颜面部异常智能诊断的高水平文章",
    'news.news19': "智能超声丨度影医疗联合发表智能三维盆底超声的高水平文章",
    'news.news20': "中秋夜 国庆悦丨人月两团圆",
    'news.news21': "NeurIPS 2023丨Pair软件助力全球超大规模医学影像标注集高效构建",
    'news.news22': "2023浦江创新论坛丨度影医疗受邀参与全球科技创新交流盛会",
    'news.news23': "标注神器！Pair软件推出动态目标分割标注智能功能iMOS",
    'news.news24': "简讯丨美国比尔及梅琳达•盖茨基金会再次到访度影医疗",
    'news.news25': "共创智能超声新时代，度影医疗“职”等你来",
    'news.news26': "从质控走向智控丨度影医疗出席第六届全国超声医学质控培训大会",
    'news.news27': "2023WAIC世界人工智能大会丨度影医疗受邀出席健康高峰论坛",
    'news.news28': "2023中国超声医师大会丨智能超声零距离",
    'news.news29': "风向标MICCAI 2023丨度影医疗五篇创新论文接收，智能超声加速迭代",
    'news.news30': "度影医疗丨“AI”草送安，端午安康",
    'news.news31': "星火燎原丨跨越五城六地的智能超声之旅",
    'news.news32': "重磅！度影医疗完成数千万Pre-A轮融资，智能超声进入3.0时代",
    'news.news33': "CMEF盛大闭幕｜度影医疗智能超声全线亮相！",
    'news.news34': "重磅首证！度影医疗获批产前超声全孕周全参数软件NMPA注册证！",
    'news.news35': "智能超声丨“国家重点研发计划-智能产前超声多中心临床研究”启动会圆满成功！",
    'news.news36': "CSUM 首届全国超声医学青年学术论坛精彩回顾｜度影医疗聚焦智能超声前沿",
    'news.news37': "度影医疗邀您共赴｜CSUM首届全国超声医学青年学术论坛 • 深圳",
    'news.news38': "“科技赋能医疗 智能助力健康”｜度影医疗受邀参与杭州医学院医学人工智能会议",
    'news.news39': "智能超声丨度影医疗三维超声智能重建开创性研究在顶级期刊发表",
    'news.news40': "“数字赋能，智赢未来”｜度影医疗亮相2023年华南医院信息网络大会",
    'news.news41': "简讯丨美国比尔及梅琳达•盖茨基金会到访度影医疗",
    'news.news42': "NVIDIA GTC 2023丨度影医疗分享超声AI前沿创新",
    'news.news43': "智能超声丨度影医疗发表稳健化医学影像分割算法高水平文章",
    'news.news44': "CHINC 2022丨度影医疗携手NVIDIA，共创智能超声新生态",
    'news.news45': "2022中华医院信息网络大会CHINC丨度影医疗邀您见证智能超声最前沿",
    'news.news46': "新年新意丨度影医疗联合Intel，深度优化全栈式智能超声解决方案",
    'news.news47': "除夕夜",
    'news.news48': "重大突破｜度影医疗高端智能超声突破CPU算力瓶颈！",
    'news.news49': "智能超声丨因为相信，不断前行。",
    'news.news50': "European Radiology丨度影医疗发表颈动脉超声智能分析顶级期刊文章",
    'news.news51': "JUM期刊｜度影医疗发表婴儿髋关节发育智能超声诊断的高水平文章",
    'news.news52': "更新！Pair标注软件推出医学影像智能交互式分割 itSeg",
    'news.news53': "GE医疗与度影医疗共筑健康新时代！2022年第五届中国国际进口博览会｜上海",
    'news.news54': "全新亮相！度影医疗全栈式智能超声｜中华医学会 CSUM2022",
    'news.news55': "度影医疗全景式智能超声即将亮相中华医学会CSUM2022",
    'news.news56': "精彩回顾丨第二届东方超声医学大会：AI在超声质控中的应用",
    'news.news57': "度影医疗助力政府贴息医疗设备改造",
    'news.news58': "热烈祝贺祖国73周年华诞！",
    'news.news59': "度影医疗携全栈式智能超声荣登NVIDIA全球开发者大会",
    'news.news60': "度影医疗受邀参与2022年全国双创展",
    'news.news61': "中秋节礼遇教师节，双节同庆！",
    'news.news62': "度影医疗智能超声标准方案突破1万件设备授权",
    'news.news63': "热烈祝贺深圳市中西医结合学会超声医学专业委员会成立",
    'news.news64': "度影医疗新址落成，智能超声扬帆起航",
    'news.news65': "2022 创业之星大赛丨度影医疗成功入围市赛半决赛",
    'news.news66': "医学标注软件 Pair｜助力临床科研创新，膺获国际临床顶刊认可",
    'news.news67': "MICCAI 2022丨度影医疗斩获国际顶级会议四篇创新性论文",
    'news.news68': "丘比特(Cupid) 产筛系统｜引领产前胎儿超声影像质控",
}
export default news_CN_Locale
